import { PermissionAttributesEnum } from "@verbleif/lib/src/composables/Permissions/permissions.enum";
import { ContextVoter } from "./composables/ContextVoter";

/**
 * Outbound credentials (`AppCredential`) are owner-scoped rows without a client, so there is no
 * context-level grant: only the platform-wide `*_any` operations exist (mirrors the backend
 * `AppCredentialVoter`, where a non-admin only reaches their own credentials).
 */
export class AppCredentialVoter extends ContextVoter {
  public canReadAny = (): boolean => {
    return !!this.permissionService.getGlobalPermissionForUser({
      attribute: PermissionAttributesEnum.GlobalOperationAppcredentialReadany,
    });
  };

  public canCreateAny = (): boolean => {
    return !!this.permissionService.getGlobalPermissionForUser({
      attribute: PermissionAttributesEnum.GlobalOperationAppcredentialCreateany,
    });
  };

  public canUpdateAny = (): boolean => {
    return !!this.permissionService.getGlobalPermissionForUser({
      attribute: PermissionAttributesEnum.GlobalOperationAppcredentialUpdateany,
    });
  };

  public canDeleteAny = (): boolean => {
    return !!this.permissionService.getGlobalPermissionForUser({
      attribute: PermissionAttributesEnum.GlobalOperationAppcredentialDeleteany,
    });
  };
}
